import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const LETTERS = "SERPENS".split("");

export default function Preloader() {
  // Show only once per session, never for crawlers / reduced-motion users (protects LCP & crawlability)
  const [done, setDone] = useState(() => {
    if (typeof window === "undefined") return true;
    const bot = /bot|crawl|spider|slurp|lighthouse|headless|google|bing|gpt|claude|perplexity/i.test(navigator.userAgent);
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    return bot || reduced || sessionStorage.getItem("serpens-preloaded") === "1";
  });

  useEffect(() => {
    if (done) return;
    sessionStorage.setItem("serpens-preloaded", "1");
    const t = setTimeout(() => setDone(true), 1200);
    return () => clearTimeout(t);
  }, [done]);

  return (
    <AnimatePresence>
      {!done && (
        <motion.div
          className="fixed inset-0 z-[100] flex items-center justify-center bg-midnight"
          exit={{ y: "-100%" }}
          transition={{ duration: 0.7, ease: [0.76, 0, 0.24, 1] }}
          data-testid="preloader"
        >
          <div className="flex overflow-hidden">
            {LETTERS.map((l, i) => (
              <motion.span
                key={i}
                initial={{ y: "110%" }}
                animate={{ y: 0 }}
                transition={{ duration: 0.6, delay: 0.15 + i * 0.07, ease: [0.22, 1, 0.36, 1] }}
                className="font-display text-4xl md:text-6xl font-bold tracking-tight text-slate-50"
              >
                {l}
              </motion.span>
            ))}
          </div>
          <motion.div
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{ duration: 1.4, delay: 0.3, ease: "easeInOut" }}
            className="absolute bottom-1/3 h-px w-40 origin-left bg-gradient-to-r from-blue-500 to-pink-400"
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
